import { createContext, useCallback, useContext, useMemo } from "react";
import useLocalStorage from "react-use/lib/useLocalStorage";
import { PaymentTerminal } from "@ticketingplatform/api/dist/paymentTerminal/__generated__/PaymentTerminal";
import { LOCAL_STORAGE_PAYMENT_TERMINAL_KEY } from "setup/consts";

export interface PaymentTerminalContextValue {
  paymentTerminal?: PaymentTerminal;
  setPaymentTerminal(value?: PaymentTerminal | null): void;
}

const PaymentTerminalContext = createContext<PaymentTerminalContextValue>({
  setPaymentTerminal: () => {
    throw new Error(
      "could not find `setPaymentTerminal()` are you sure you are inside of `PaymentTerminalContextProvider` provider?"
    );
  },
});

export const PaymentTerminalContextProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const [paymentTerminal, setPaymentTerminalValue, removePaymentTerminalValue] =
    useLocalStorage<PaymentTerminal>(LOCAL_STORAGE_PAYMENT_TERMINAL_KEY);

  const setPaymentTerminal = useCallback(
    async (value?: PaymentTerminal | null) => {
      if (value) {
        setPaymentTerminalValue(value);
      } else {
        removePaymentTerminalValue();
      }
    },
    [removePaymentTerminalValue, setPaymentTerminalValue]
  );

  const value = useMemo(
    () => ({ paymentTerminal, setPaymentTerminal }),
    [setPaymentTerminal, paymentTerminal]
  );

  return (
    <PaymentTerminalContext.Provider {...{ value }}>
      {children}
    </PaymentTerminalContext.Provider>
  );
};

export const usePaymentTerminalContext = () =>
  useContext(PaymentTerminalContext);
